import { render, staticRenderFns } from "./SpaceSettingsStorage.vue?vue&type=template&id=422ea47c&"
import script from "./SpaceSettingsStorage.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports